module.exports = __webpack_public_path__ + "img/noData.3e36dc1a.png";